import React from 'react';

import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { ResourceFilter } from 'components/common/GlobalFilterComponent/components/ResourceFilter/resourceFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { ProgressMeasurementFilter } from 'components/common/GlobalFilterComponent/components/progressMeasurementFilter/progressMeasurementFilter';
import { ResourceTypeFilter } from 'components/common/GlobalFilterComponent/components/resourceTypeFilter/resourceTypeFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgramProgressOverviewQueryKey } from 'components/Dashboards/Project/Components/VersionCompare/VersionCompare.consts';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { DelayedActivities } from 'components/widgets/DelayedActivities/DelayedActivities';
import { HighLevelProgram } from 'components/widgets/HighLevelProgram/HighLevelProgram';
import { MilestonesDistribution } from 'components/widgets/MilestonesDistribution/MilestonesDistribution';
import { ProgressSummary } from 'components/widgets/ProgressSummary/ProgressSummary';
import { CriticalityWeightedSCurve } from 'components/widgets/SCurve/Scurve';
import { useProgressMeasurement } from 'components/widgets/SubProgramPreferences/components/progressMeasurement/components/progressMeasurementPreference/useProgressMeasurementPreference';

export const ProgressPage = () => {
    useFullStoryPageView({ pageName: executionConfig.progressOverview.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramProgressOverviewQueryKey.includes(key);
        },
    });
    useScrollTo(isFetching);

    const { value: progressMeasurementValue } = useProgressMeasurement();
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                    <ShareInsightButton title={executionConfig.progressOverview.title} link={window.location.href} />
                    <GlobalFilterButton />
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.progressOverview.title} />
                    {progressMeasurementValue !== undefined && (
                        <GlobalFilterComponent
                            defaultValues={{
                                progressMeasurement: progressMeasurementValue,
                                milestoneFragnet: null,
                                tags: [],
                                activityCodes: [],
                                wbs: null,
                                resourceType: null,
                                resource: null,
                            }}
                        >
                            <ProgressMeasurementFilter name={'progressMeasurement'} />
                            <MilestoneFragnetFilter name={'milestoneFragnet'} />
                            <TagsFilter name={'tags'} />
                            <ActivityCodesFilter name={'activityCodes'} />
                            <WbsFilter name={'wbs'} />
                            <ResourceTypeFilter name={'resourceType'} />
                            <ResourceFilter name={'resource'} />
                        </GlobalFilterComponent>
                    )}
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ProgressSummary />
                    <CriticalityWeightedSCurve />
                    <DelayedActivities />
                    <HighLevelProgram />
                    <MilestonesDistribution />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramProgressOverviewQueryKey} />
        </PageContainer>
    );
};
